<template>
  <el-dialog
    :title="openType === 'add' ? '新增地区' : '编辑地区'"
    :visible.sync="visible"
    :close-on-click-modal="false"
    destroy-on-close
    custom-class="customModal" >
    <el-form ref="form" :model="formValue" :rules="rules">
      <el-form-item label="地区名称" prop="name" class="formItemFill">
        <el-input v-model="formValue.name" size="small" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="是否启用" prop="is_enable" class="formItemFill" >
        <el-radio-group v-model="formValue.is_enable" size="small" style="width: 100%">
          <el-radio-button :label="true">是</el-radio-button>
          <el-radio-button :label="false">否</el-radio-button>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <AppButton type="primary" @click="submit" size="small">确 定</AppButton>
      <AppButton @click="close" size="small">取 消</AppButton>
    </div>
  </el-dialog>
</template>

<script>
import { WebsiteService } from '../../service/website.service';
  export default {
    name: 'formAuthorize',
    data() {
      return {
        treeData: [],
        visible: false,
        openType: '',
        formValue: { },
        rules: {
          name: [{ required: true, message: '地区名称不能为空'}],
        }
      }
    },
    methods: {
      open(type, data) {
        if (type === 'add' && !data.hasOwnProperty('is_son') ) {
          this.reset();
        } 
        else if(type === 'add'){
          const result = JSON.parse(JSON.stringify(data));
          this.formValue = result;
          this.formValue.is_enable = true
          this.formValue.name = ''
          this.formValue.parent_id = this.formValue.id
          this.formValue.level = this.formValue.level + 1
          delete(this.formValue['id'])
          delete(this.formValue['is_son'])
          delete(this.formValue['hasChildren'])
        }
        else if (type === 'edit') {
          const result = JSON.parse(JSON.stringify(data));
          this.formValue = result;
        }
        this.openType = type;
        this.visible = true;
      },
      reset() {
        this.formValue = {
          parent_id: 0,
          is_enable: true,
          level: 1
        };
      },
      async submit() {
        const result = await this.$refs.form.validate();
        if (result) {
          this.formValue.is_enable = this.formValue.is_enable === true ? 1 : 0
          await WebsiteService.saveRegion(this.formValue);
          this.$emit('submitSuccess')
          this.close();
        }
      },
      close() {
        this.visible = false;
        this.formValue = {};
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>